import React from 'react';
import DS_Problems from '../../../sections/DS_Problems';
import { StyledEntryCards } from './EmbeddedEntryCardsStyles';

/**
 * Render embedded DS_problems in rich text
 *
 * @returns {React.ReactElement}
 */
function EmbeddedEntryCards(fields) {
  const { problemCards } = fields;
  return (
    <StyledEntryCards>
      <DS_Problems problemCards={problemCards} />
    </StyledEntryCards>
  );
}

export default EmbeddedEntryCards;
